import { AxiosError } from "axios";

const CREDENTIAL_FAILURE_STATUSES = new Set([400, 401, 403, 422]);

export function validateLoginEmail(value: string): string | undefined {
  if (!value.trim()) {
    return "Email is required";
  }
  if (!/\S+@\S+\.\S+/.test(value)) {
    return "Please enter a valid email address";
  }
  return undefined;
}

export function validateLoginPassword(value: string): string | undefined {
  if (!value.trim()) {
    return "Password is required";
  }
  if (value.length < 6) {
    return "Password must be at least 6 characters";
  }
  return undefined;
}

export function isCredentialFailure(error: unknown): boolean {
  return (
    error instanceof AxiosError &&
    error.response?.status !== undefined &&
    CREDENTIAL_FAILURE_STATUSES.has(error.response.status)
  );
}

export function getRetryAfterSeconds(error: unknown): number | undefined {
  if (!(error instanceof AxiosError) || error.response?.status !== 429) {
    return undefined;
  }

  const retryAfter = error.response.headers["retry-after"];
  if (typeof retryAfter !== "string") {
    return 60;
  }

  const seconds = Number.parseInt(retryAfter, 10);
  if (Number.isFinite(seconds) && seconds > 0) {
    return seconds;
  }

  const retryDate = Date.parse(retryAfter);
  if (Number.isNaN(retryDate)) {
    return 60;
  }

  return Math.max(1, Math.ceil((retryDate - Date.now()) / 1000));
}
